<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="供应商" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.name" placeholder="供应商名称" clearable></el-input></el-col>
        <el-col :span="5"><el-input v-model="query.contact" placeholder="联系人" clearable></el-input></el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="名称" prop="name" width="200"></el-table-column>
        <el-table-column label="联系人" prop="contact" width="120"></el-table-column>
        <el-table-column label="电话" prop="phone" width="150"></el-table-column>
        <el-table-column label="地址" prop="address" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="名称" required><el-input v-model="form.name"></el-input></el-form-item>
        <el-form-item label="联系人"><el-input v-model="form.contact"></el-input></el-form-item>
        <el-form-item label="电话"><el-input v-model="form.phone"></el-input></el-form-item>
        <el-form-item label="地址"><el-input v-model="form.address"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, name: '', contact: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {}
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/suppliers', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.dialogTitle = '新增供应商'
      this.form = { name: '', contact: '', phone: '', address: '' }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑供应商'
      this.form = Object.assign({}, row)
      this.show = true
    },
    save () {
      if (!this.form.name) { this.$message.warning('名称必填'); return }
      if (this.form.id) {
        this.$axios.put(`/suppliers/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/suppliers', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/suppliers/${id}`, () => this.getData())
    }
  }
}
</script>
